import { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { analytics } from "./client";

/**
 * Catches React render errors (which window.onerror does not) and reports them
 * to PostHog error tracking via captureException (consent-gated). Shows a simple
 * fallback so a render crash doesn't leave a blank screen.
 */
class AnalyticsErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    analytics.captureException(error, { componentStack: info?.componentStack });
  }

  render() {
    const { t, children } = this.props;
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
          <h1 className="text-lg font-semibold">{t("errorBoundary.title")}</h1>
          <p className="text-muted-foreground">{t("errorBoundary.description")}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-md bg-primary px-4 py-2 text-primary-foreground"
          >
            {t("errorBoundary.reload")}
          </button>
        </div>
      );
    }
    return children;
  }
}

AnalyticsErrorBoundary.propTypes = {
  children: PropTypes.node,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AnalyticsErrorBoundary);
